import { SignUp } from '@clerk/react';
import { useTheme } from '@/contexts/ThemeContext';
import { getClerkAppearance } from '@/lib/clerk-appearance';
import { openCookieSettings } from '@/lib/consent';
import { getMarketingSiteUrl } from '@/lib/site';

const MARKETING_SITE_URL = getMarketingSiteUrl();

const SignUpPage = () => {
  const { resolvedMode } = useTheme();

  return (
    <div className="flex min-h-screen items-center justify-center bg-background px-4">
      <div className="w-full max-w-md">
        <div className="mb-8 text-center">
          <h1 className="text-2xl font-semibold tracking-tight text-foreground">MerchMuse</h1>
          <p className="mt-2 text-sm text-muted-foreground">Create your account to get started</p>
        </div>
        <SignUp
          appearance={getClerkAppearance(resolvedMode, {
            rootBox: 'mx-auto',
            card: 'border border-border bg-card shadow-lg',
          })}
          routing="path"
          path="/sign-up"
          signInUrl="/sign-in"
          forceRedirectUrl="/"
        />
        <p className="mt-6 text-center text-xs text-muted-foreground">
          <a
            href={`${MARKETING_SITE_URL}/privacy/`}
            target="_blank"
            rel="noreferrer"
            className="underline hover:text-foreground"
            data-ph-event="navigation_clicked"
            data-ph-component="auth_footer"
            data-ph-element="privacy_policy"
            data-ph-dest-type="external_page"
            data-ph-dest={`${MARKETING_SITE_URL}/privacy/`}
          >
            Privacy Policy
          </a>{' '}
          ·{' '}
          <button
            type="button"
            onClick={openCookieSettings}
            className="underline hover:text-foreground"
            data-ph-event="cta_clicked"
            data-ph-component="auth_footer"
            data-ph-element="cookie_settings"
          >
            Cookie Settings
          </button>
        </p>
      </div>
    </div>
  );
};

export default SignUpPage;
